import React from 'react';
import PropTypes from 'prop-types';
import { Field as FormField } from 'redux-form';
import styled, { css } from 'styled-components';
import { Theme, colors } from '../../legacy/hui/src/styled/theme';
import ReactTooltip from 'react-tooltip';

/*copied from hui component todo fix */
const StyledField = styled(FormField)`
  ${props =>
    props.type !== 'checkbox' &&
    css`
      width: 100%;
      font-size: 16px;
      border: 0;
      border-radius: 4px;
      appearance: none;
      outline: 0;
      border: 1px solid ${colors.GREY};
      position: relative;
      padding: 11px 20px;
    `};
`;

export const StyledLabel = styled.label`
  ${props =>
    props.type !== 'checkbox' &&
    css`
      font-size: 13px;
      position: absolute;
      left: 5px;
      top: -6px;
      padding: 0 5px;

      background-color: ${Theme.snow};
    `} ${props =>
    props.type == 'checkbox' &&
    css`
      margin: 5px 0 20px;
      display: block;

      input {
        float: left;
        margin-right: 10px;
        margin-top: 3px;
      }
    `};
`;

const FieldInfoLabel = styled.span`
  float: right;
  font-size: 13px;
  color: ${Theme.muted};
  margin: 3px 0;
  cursor: pointer;
`;

const FieldWrapper = styled.div`
  position: relative;
  margin-bottom: 25px;
`;

export const ErrorText = styled.div`
  color: #ca3121;
  padding: 10px 0;
  font-size: 14px;
`;

const renderField = ({ input, meta, ...rest }) => {
  return (
    <div className="input-row">
      <input type="text" {...input} {...rest} />
      {meta.error && meta.touched && <ErrorText className="error">{meta.error}</ErrorText>}
    </div>
  );
};

renderField.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object
};

const Field = ({
  label,
  name,
  component = renderField,
  placeholder = '',
  fieldInfoLabel,
  fieldInfoValue,
  type,
  children,
  className,
  ...rest
}) => {
  if (type == 'checkbox') {
    return (
      <StyledLabel type={type}>
        {' '}
        {label}
        <StyledField
          name={name}
          component={'input'}
          placeholder={placeholder}
          type={type}
          {...rest}
        >
          {children}
        </StyledField>
      </StyledLabel>
    );
  }

  return (
    <FieldWrapper>
      <StyledField
        name={name}
        component={component}
        placeholder={placeholder}
        type={type}
        className={className}
        {...rest}
      >
        {children}
      </StyledField>
      <StyledLabel type={type} component={component}>
        {' '}
        {label}
      </StyledLabel>

      {fieldInfoLabel && (
        <FieldInfoLabel data-tip={fieldInfoValue}>
          {fieldInfoLabel}
          <ReactTooltip multiline />
        </FieldInfoLabel>
      )}
    </FieldWrapper>
  );
};

Field.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  component: PropTypes.node,
  placeholder: PropTypes.string,
  fieldInfoLabel: PropTypes.string,
  fieldInfoValue: PropTypes.string,
  type: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string
};

export default Field;
